<template>
  <div class="set-index">
    <template v-for="(item, index) in menu" :key="index">
      <div class="line" v-if="index != 0"></div>
      <div class="group">
        <div
          class="title"
          :style="{
            paddingLeft: item.icon ? '40px' : 0,
          }"
        >
          <img
            v-if="item.icon"
            class="title-icon"
            :class="item.className"
            :src="item.icon"
          />
          {{ item.name }}
        </div>
        <div class="list">
          <template v-for="(v, k) in item.arr" :key="k">
            <router-link v-if="v.to" :to="v.to" class="item">
              {{ v.name }}
            </router-link>
            <div v-else @click="() => v.handler()" class="item btn">
              {{ v.name }}
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Page",
  props: ["menu"],
  components: {},
};
</script>
<style scoped lang="less" src="./index.less"></style>
<style scoped>
.title {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 40px;
}
.title-icon {
  width: 40px;
  height: 26px;
  margin-right: 15px;
  position: absolute;
  left: 0;
}
.title-icon-0 {
}
.title-icon-1 {
  width: 31px;
  height: 31px;
}
</style>
